import React from 'react';
import { Menu, X, Sparkles } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';

export default function Header() {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <header className="fixed w-full bg-white/90 backdrop-blur-sm z-50 shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="flex flex-col">
              <span className="text-2xl font-extrabold text-primary-900">Shortmaker</span>
              <span className="text-[10px] text-gray-400 font-normal -mt-1">by Solomaker</span>
            </div>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-primary-600 hover:text-primary-900 transition-colors font-bold">機能</a>
            <a href="#pricing" className="text-primary-600 hover:text-primary-900 transition-colors font-bold">料金</a>
            <LanguageSwitcher />
            <button className="group relative px-6 py-2 rounded-full overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="absolute inset-0 bg-gradient-to-r from-primary-600 to-accent-500 transition-all duration-300 group-hover:scale-[1.02] group-hover:brightness-110"></div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-white transition-opacity duration-300"></div>
              <div className="relative flex items-center justify-center gap-2 text-white transition-transform duration-300 group-hover:scale-[1.02]">
                <span className="group-hover:tracking-wide transition-all duration-300 font-bold">β版を試してみる</span>
              </div>
            </button>
          </div>

          <div className="md:hidden flex items-center gap-4">
            <button className="group relative px-4 py-2 rounded-full overflow-hidden shadow-md hover:shadow-lg transition-all duration-300">
              <div className="absolute inset-0 bg-gradient-to-r from-primary-600 to-accent-500 transition-all duration-300 group-hover:scale-[1.02] group-hover:brightness-110"></div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-white transition-opacity duration-300"></div>
              <div className="relative flex items-center justify-center gap-1 text-white transition-transform duration-300 group-hover:scale-[1.02]">
                <span className="text-sm font-bold whitespace-nowrap">β版</span>
              </div>
            </button>
            <button 
              className="p-1"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {isOpen && (
          <div className="md:hidden mt-4 space-y-4">
            <a href="#features" className="block text-primary-600 hover:text-primary-900 transition-colors font-bold">機能</a>
            <a href="#pricing" className="block text-primary-600 hover:text-primary-900 transition-colors font-bold">料金</a>
            <LanguageSwitcher />
            <button className="group relative w-full px-6 py-2 rounded-full overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="absolute inset-0 bg-gradient-to-r from-primary-600 to-accent-500 transition-all duration-300 group-hover:scale-[1.02] group-hover:brightness-110"></div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-white transition-opacity duration-300"></div>
              <div className="relative flex items-center justify-center gap-2 text-white transition-transform duration-300 group-hover:scale-[1.02]">
                <Sparkles className="w-4 h-4 transition-transform duration-300 group-hover:rotate-12" />
                <span className="group-hover:tracking-wide transition-all duration-300 font-bold">早期アクセスに参加 👀</span>
              </div>
            </button>
          </div>
        )}
      </nav>
    </header>
  );
}
